/**
 * Masks a Brazilian document for display: first 3 digits + **** + last 2.
 * Non-digit characters are ignored for masking; returns '—' when too short.
 */
export function maskDocumento(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '—';
  if (digits.length <= 5) return `${digits[0] || ''}***${digits.slice(-1)}`;

  return `${digits.slice(0, 3)}****${digits.slice(-2)}`;
}

/** Formats a CPF (11) or CNPJ (14) for display. Other values are returned trimmed. */
export function formatCpfCnpj(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (digits.length === 14) {
    return digits.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  }
  return String(value || '').trim();
}

/** Formats an ISO date (YYYY-MM-DD) for UI display as dd/mm/yyyy. */
export function formatVencimento(value) {
  if (!value) return '—';
  const text = String(value).slice(0, 10);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return String(value);
  return `${match[3]}/${match[2]}/${match[1]}`;
}
